import React, { useRef, useEffect, useState } from "react";

type NameDialogProps = {
  open: boolean;
  initialName?: string;
  onSave: (name: string) => void;
  onClose: () => void;
};

export function NameDialog({ open, initialName = "", onSave, onClose }: NameDialogProps) {
  const [name, setName] = useState(initialName);
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open) {
      if (!dialog.open) dialog.showModal();
    } else {
      if (dialog.open) dialog.close();
    }
  }, [open]);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    const handleClose = () => onClose();
    dialog.addEventListener("close", handleClose);
    return () => dialog.removeEventListener("close", handleClose);
  }, [onClose]);

  useEffect(() => {
    if (open) setName(initialName);
  }, [open, initialName]);

  return (
    <dialog ref={dialogRef} className="name-dialog">
      <form
        method="dialog"
        onSubmit={(e) => {
          e.preventDefault();
          if (!name.trim()) return;
          onSave(name.trim());
        }}
      >
        <div className="name-dialog-inner">
          <h3>Pilot, podaj swój znak wywoławczy</h3>
          <p>Tylko z imieniem trafisz na listę najlepszych kapitanów galaktyki.</p>
          <input
            className="name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Twoje imię"
            autoFocus
            maxLength={24}
          />
          <div className="name-dialog-actions">
            <button type="submit" className="btn-primary" disabled={!name.trim()}>
              Zapisz
            </button>
            <button type="button" className="btn-ghost" onClick={onClose}>
              Anuluj
            </button>
          </div>
        </div>
      </form>
    </dialog>
  );
}
